import React, {useState,useEffect} from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import ImageError from '../error/error'
import { url } from '../../App'
import Skeleton from '../skeleton/skeleton'

const Box = styled(Link)`
    width:300px;
    height:180px;
    border-radius:4px;
    border:1px solid rgba(0,0,0,0.1);
    display:flex;
    box-shadow: 0 2px 2px 1px rgba(0,0,0,0.1);
    position:relative;
    flex-direction:column;
    text-decoration: none;
   
    @media screen and (max-width: 1100px){
        margin-bottom:20px;
    }
`
export const Div = styled('div')`
    display:flex;
    position: relative;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    margin-top:50px;
    margin-bottom:50px;

`
const WrappImage = styled.div`
    width:100%;
    transition:.5s ease-in;
    &:hover{
        transform: scale(1.1);
    }
`

const ImgProject = styled.img`
    width: 100%;
    object-fit:contain;
    border-radius: 4px 4px 0 0 ;
`
const WrappJudul = styled.div`
    display:flex;
    position:relative;
    justify-content: center;
    align-items:center;
    /* padding:20px; */
    padding-right: 10px;
    padding-left: 10px;
`
const TitleProject = styled(Link)`
    font-size:14px;
    color:#000;
    &:hover{
        text-decoration:none;
    }
`
const JudulProject = styled.p`
    color:#000;
    font-size:14px;
    margin-top:-80px;
`
function Projects(){
    const [ data, setData ] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    async function getProject(){
        setLoading(true)
        try{
            let res = await fetch(`${url}/get-project`)
            let data = await res.json()
            setData(data.data)
        }catch(error){
            setError(true)
        }finally{
            setLoading(false)
        }
    }
    useEffect(() => {
      getProject()
    },[])
    
   if(error){
       return(
           <ImageError />
       )
   }
   if(loading){
       return(
           <Skeleton width={"300px"} height={"280px"} amount={3} />
       )
   }

        return(
            <>
                {
                    data.map(item => {
                        console.log(item);
                        return(
                        <Box key={item.id} to={'projects/'+ item.id}>
                            <WrappImage>
                                <ImgProject src={item.image}  alt="Website" />
                            </WrappImage>
                            {/* <WrappJudul> 
                            <JudulProject>{item.nama.substr(0,40) + '...'}</JudulProject>
                            <TitleProject to={'projects/'+item.id}>{item.id}</TitleProject>
                            </WrappJudul> */}
                        </Box>
                        )
                    })
                }
           </>
        )
}
export default Projects